import React from 'react';

interface ErrorNotificationProps {
    headerTitle: string,
    content: string
}

const ErrorNotification: React.FC<ErrorNotificationProps> = ({ headerTitle, content }) => {
    return (
        <div className='error'>
            <div className='d-flex w-100'>
                <div className='col-2'>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="#A51B0D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M12 16H12.01" stroke="#A51B0D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M12 8V12" stroke="#A51B0D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </div>

                <div className='col'>
                    <div className='d-flex header-title w-100'>
                        {headerTitle}
                    </div>
                    <div className='d-flex content-success-notif w-100'>
                        {content}
                    </div>
                </div>

            </div>
        </div>
    );
}
export default ErrorNotification;
